export default {
    STATUS_CODE: {
        SUCCESS: 200,
        NO_LOGIN: 602,
        UNDEFINED: undefined,
    },
    navigation: {
        crowd: '', // 使用人群，分 B、C
        textAlign: 'center'
    },
    LOGIN_PAGE: ['login', 'register', 'forget'],
};
